import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";

export default function NotificationsPanelHeader({ handleMarkAllAsRead }) {
  return (
    <Box sx={{ margin: "0px 16px 8px 16px", display: "flex", alignItems: "center", backgroundColor: "white_opacity.100" }}>
      <Typography variant="h2" color="black_solid.100">
        Notifications
      </Typography>
      <Box sx={{ marginLeft: "auto", "&:hover": {cursor: "pointer"} }} onClick={handleMarkAllAsRead}>
        <Typography variant="subhead2" color="primary.60">
          Mark all as read
        </Typography>
      </Box>
    </Box>
  );
}

NotificationsPanelHeader.propTypes = {
  handleMarkAllAsRead: PropTypes.func.isRequired
};